<template>
  <Modal
    :value="isModal"
    footer-hide
    :mask-closable="false"
    title="选择问卷"
    :z-index="999"
    @on-cancel="cancel"
    width="640"
  >
    <div style="display:flex">
      <div style="color:#333;flex:1;text-align: center;">问卷分类</div>
      <div style="color:#333;flex:1;text-align: center;">问卷名称</div>
    </div>

    <div class="address-container" v-loading="loading">
      <!--左侧分类列表-->
      <div class="address-content">
        <div class="dept-list">
          <el-tree
            :data="typeLists"
            node-key="group_id"
            :props="defaultProps"
            :highlight-current="showTree"
            @node-click="handleNodeClick"
            :expand-on-click-node="false"
          ></el-tree>
        </div>
      </div>
      <!--右侧某分类下问卷-->
      <div class="dept-choose-doctors" v-loading="loading1">
        <div class="doctor-list-item" v-for="(i, index) in quesList" :key="index">
          <RadioGroup v-model="Radiovalue" @on-change="selectRadio($event)">
            <Radio :label="i.questionnaire_id">&nbsp;{{ i.questionnaire_name }}</Radio>
          </RadioGroup>
        </div>

        <div
          v-if="quesList.length === 0 && !loading &&!loading1"
          style="line-height: 40px; text-align: center; color: #c5c8ce"
        >暂无数据</div>
      </div>
    </div>
    <div style="text-align: center; margin-top: 16px">
      <Button @click="cancel">取消</Button>
      <Button type="primary" style="margin-left: 20px" @click="submit">保存</Button>
    </div>
  </Modal>
</template>

<script>
export default {
  name: 'ConditionFilter',
  props: {
    isModal: {
      type: Boolean,
      default: false,
    },
    category_id: {
      type: String | Number,
      default: '',
    },
  },
  data() {
    return {
      list: [],
      quesList: [],
      quesId: '',
      quesInfo: {},
      defaultProps: {
        children: 'children',
        label: 'text',
      },
      typeLists: [],
      text: '',
      showTree: true,
      Radiovalue: '',
      isModalShow: false,
      haveData: true,
      loading: true,
      loading1: true,
    }
  },
  computed: {
    windowHeight: function () {
      return window.innerHeight
    },
  },
  watch: {
    isModal(newVal) {
      if (newVal) {
        this.typeLists = []
        this.typeCode = ''
        this.list = []
        this.quesList = []
        this.quesId = ''
        this.quesInfo = {}
        this.Radiovalue = ''
        this.text = ''

        this.getQues()
      }
    },
  },
  methods: {
    handleNodeClick(data) {
      this.typeCode = data.id
      this.Radiovalue = ''
      this.getQuesList()
    },
    getquesInfo(id) {
      let self = this
      let quesId = self.quesId
      if (id) {
        quesId = id
      }

      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUESTIONNAIRE') + '/' + quesId,
        headers: {
          'content-type': 'application/json',
        },
        success: function (res) {
          if (res.code === 0) {
            self.quesInfo = res.data
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    getQues() {
      var self = this
      let shift = self.$store.state.shift
      self.loading = true
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUES_CATEGORY'),
        data: {
          // disease_id: shift.disease_id,
          // category_id: self.category_id,
          disease_id: shift.disease_id,
          dept_id: shift.dept_id,
        },
        success: (res) => {
          self.loading = false
          if (res.code === 0) {
            self.typeLists = res.data
            self.typeCode = res.data[0].id
            self.getQuesList()
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    getQuesList() {
      var self = this
      self.quesList = []
      self.loading1 = true
      self.$utils.caringRequest({
        method: 'GET',
        url: self.$utils.getInterface('QUES_NEWS'),
        data: {
          category_id: self.typeCode,
          page: 1,
          size: 999,
        },
        success: function (res, response) {
          self.loading1 = false
          self.total = Number(response['x-total-count']) || 0
          if (res.code === 0) {
            self.quesList = res.data
          } else {
            self.$Message.error(res.message)
          }
        },
      })
    },
    cancel() {
      this.$emit('cancel')
    },
    submit() {
      this.quesId = this.Radiovalue
      let info = []
      this.quesList.forEach((v) => {
        if (this.quesId == v.questionnaire_id) {
          info.push(v)
        }
      })
      this.$emit('save', info)
    },
    selectRadio(data) {
      console.log(data)
    },
  },
  mounted() {
    // this.getQues()
  },
}
</script>

<style lang="less">
.address-container {
  margin-top: 12px;
  display: flex;
  border-radius: 4px;
  border: solid 1px #eee;

  .address-content {
    width: 0;
    flex: 1;
    border-right: solid 1px #eee;
    background: #f8f8f8;
    .dept-list-search {
      padding: 10px 12px;
      border-bottom: solid 1px #eee;
    }

    .dept-list {
      padding: 10px 12px;
      height: 400px;
      overflow-y: auto;
      .el-tree {
        background: #f8f8f8;
      }
      .dept-list-item {
        height: 24px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;

        .dept-list-item-active {
          color: #000;
          font-weight: bold;
        }
      }
      .el-tree-node__label {
        font-size: 16px;
      }
    }
  }

  .dept-choose-doctors {
    flex: 1;
    padding: 10px 12px;
    overflow-y: auto;
    height: 400px;
    .doctor-list-item {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      .ivu-radio-wrapper {
        font-size: 15px;
        line-height: 32px;
        white-space: normal;
      }
    }
  }
  .el-tree-node__content {
    height: 32px;
  }
  .el-tree--highlight-current
    .el-tree-node.is-current
    > .el-tree-node__content {
    background-color: #e6f0ff;
  }
  .is-leaf .el-tree-node__label,
  .el-tree-node__children .el-tree-node__content {
    color: #999;
  }
}
</style>
